import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import { getPopularArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const popularArticles = getPopularArticles(4);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">
              最受读者欢迎的精品内容，不容错过
            </p>
          </div>
          <Link
            to="/category/yingshi"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {popularArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}